import React, { useEffect, useState } from 'react';
import { Button, Modal, Form } from 'antd';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import DynamicForm from '@/components/DynamicForm';
import improve_warning from '@/assets/images/improve_warning.png';
import utils from 'grt-tool-lib-front';
import moment from 'moment';
import s from './style.m.less';
utils.chineseDate(moment);
const InformationModal = (props) => {
    const [disabled, setDisabled] = useState(false),
        { informationVisible, improve_info, submitImproveInfo, setInformationVisible } = props.store.login,
        { field_key, field_value } = improve_info,
        [improveInfoForm] = Form.useForm(),
        onSubmit = () => {
            improveInfoForm.submit();
        },
        onFinish = async (values) => {
            setDisabled(true);

            await submitImproveInfo(values);
            setDisabled(false);
        },
        //编辑的时候，要处理下数据，用于表单回显
        handleInitData = () => {
            let tem_field_value = field_value,
                tem_field_key = field_key;
            tem_field_key?.forEach((ele) => {
                // 日期类型
                if (ele.field_type === 5 && tem_field_value[ele.en_name]) {
                    if (ele.setting.type === 'range') {
                        let [start, end] = tem_field_value[ele.en_name];
                        tem_field_value[ele.en_name] = [moment(start), moment(end)];
                    } else {
                        tem_field_value[ele.en_name] = moment(tem_field_value[ele.en_name]);
                    }
                }
            });
            return tem_field_value;
        },
        getVerifyFormItems = () => {
            let result = [],
                formList = field_key;
            if (formList && formList.length) {
                const configList = toJS(formList);
                let requiredList = [],
                    otherList = [],
                    list;
                configList.filter((item) => {
                    if (item.required === 0) {
                        requiredList.push(item);
                    } else {
                        otherList.push(item);
                    }
                    return true;
                });
                requiredList.sort((a, b) => {
                    return parseInt(a.create_time) - b.create_time;
                });
                otherList.sort((a, b) => {
                    return parseInt(a.create_time) - b.create_time;
                });
                list = requiredList.concat(otherList);
                for (const item of list) {
                    result.push(
                        <div key={item.field_id}>
                            <DynamicForm status={'edit'} {...item}></DynamicForm>
                        </div>
                    );
                }
            }
            return result;
        };
    useEffect(() => {
        if (field_value) {
            improveInfoForm.setFieldsValue(handleInitData());
        }
    }, [field_value]);
    const onCancel = () => {
        if (props?.onCancel) {
            props.onCancel();
        } else {
            setInformationVisible(false);
        }
    };
    return (
        <div>
            <Modal
                open={informationVisible}
                destroyOnClose={true}
                title={props.title || '完善身份信息'}
                footer={null}
                width={760}
                className="info_content"
                closable={props.closable === undefined ? false : props.closable}
                maskClosable={false}
                keyboard={false}
                forceRender
                onCancel={onCancel}
            >
                <div style={{ width: '696px', height: '54px', padding: '16px', marginBottom: '32px', background: '#FFF7EA' }}>
                    <img src={improve_warning} alt="" style={{ width: '20px', marginRight: '8px' }}></img>
                    {props.tip || '根据赛事要求，请您补充以下信息，确保无误后提交，感谢您的理解。'}
                </div>
                <div className={s['form-box']}>
                    <Form
                        form={improveInfoForm}
                        name="basic"
                        onFinish={onFinish}
                        validateTrigger="onBlur"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        style={{ marginLeft: '90px', marginRight: '110px' }}
                    >
                        <div style={{ flex: 1 }}>{getVerifyFormItems()}</div>
                    </Form>
                </div>
                <div style={{ textAlign: 'center', marginTop: '32px' }}>
                    <Button disabled={disabled} style={{ width: '228px' }} type="primary" onClick={() => onSubmit()}>
                        提交信息
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default inject('store')(observer(InformationModal));
